import { VisitorsCardsContextProvider } from '@va/dashboard/modules/visitors';
import { LoadingLogo, NoDataMessage } from '@va/ui/design-system';
import { IntersectionObserverProvider } from '@va/util/misc';
import { MappedWebsite } from '../agency-white-label-v2/agency-white-label-apiClient';
import { useManageWebsitesContext } from './ManageWebsiteContext';
import WebsitesTableRow from './WebsitesTableRow';

export const ManageWebsitesTable = () => {
  const { websitesData, isLoading, totalWebsites } = useManageWebsitesContext();

  if (isLoading) {
    return (
      <div className='relative flex justify-center w-full h-44'>
        <LoadingLogo />
      </div>
    );
  }

  if (totalWebsites > 0) {
    return (
      <div className='border-2 sm:border-0 border-solid border-white-smoke rounded-12'>
        <WebsitesList allWebsitesList={websitesData?.websites ?? []} />
      </div>
    );
  }

  return <NoDataMessage type={'panel'} />;
};

const WebsitesList = ({ allWebsitesList }: { allWebsitesList: MappedWebsite[] }) => {
  if (allWebsitesList) {
    return (
      <VisitorsCardsContextProvider>
        {allWebsitesList.map((website, index) => (
          <IntersectionObserverProvider key={website.id}>
            <WebsitesTableRow website={website} index={index} />
          </IntersectionObserverProvider>
        ))}
      </VisitorsCardsContextProvider>
    );
  }
  return null;
};
